module.exports = __webpack_public_path__ + "img/more.56ff9aab.svg";